import React from "react";
import Marquee from "react-fast-marquee";

const Brands = () => {
  const images = [
    "/assets/Images/Brands/ACC.png",
    "/assets/Images/Brands/Adita birla.png",
    "/assets/Images/Brands/Ambuja Cement.png",
    "/assets/Images/Brands/asian paints.png",
    "/assets/Images/Brands/dr fixt.png",
    "/assets/Images/Brands/godrej.png",
    "/assets/Images/Brands/Hi-tech.png",
    "/assets/Images/Brands/JSW.png",
    "/assets/Images/Brands/pidilite.png",
    "/assets/Images/Brands/Ultra-tech.png",
  ];

  return (
    <div className="p-4">
      <p className=" text-blue-950 font-bold md:text-2xl text-center text-xl">
        Brands
      </p>

      <div className="relative overflow-hidden lg:-mt-5">
        {/* Marquee Component */}
        <Marquee speed={80} gradient={false} className="flex items-center">
          {images.map((src, index) => (
            <img
              key={`brand-${index}`}
              src={src}
              alt={`Brand ${index + 1}`}
              className="object-contain w-16 h-20 md:mx-8 mx-4 md:w-28 md:h-28 lg:w-40 lg:h-40"
            />
          ))}
        </Marquee>
      </div>
    </div>
  );
};

export default Brands;
